import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  display: flex;

  @media ${breakpoints.tablet.max.sm} {
    width: 100%;
    overflow: hidden;
  }
`;

export const ListContainer = styled.div`
  height: 44px;
  display: flex;
`;
